import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	gap: 50px;
	padding: 20px 40px 10px 40px;
`;

export const Separator = styled.div`
	border-right: 2px solid ${tokens.color_gray_light};
`;
